<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectShippingOption" });
import { SelectSingle } from "../../../../selects/index.js";
import { SHIPPING_OPTIONS } from "../../config/shipping-options.js";
import { t } from "svelte-i18n";
export let key;
export let label = "resource.auction.properties.shipping.options.label";
export let placeholder = "resource.auction.properties.shipping.options.placeholder";
export let options = [];
export let isDisabled = false;
export let isRequired = false;
export let whitelist = [];
const mapLabels = (key2) => {
    const LABEL = SHIPPING_OPTIONS.find((option) => option.key === key2)?.label;
    if (LABEL === void 0) {
        return { key: key2, label: key2 };
    }
    return { key: key2, label: LABEL };
};
const addLabel = ({ key: key2, label: label2 }) => ({ key: key2, label: $t(label2) });
$: OPTIONS = (options.length > 0 ? options.map(mapLabels) : SHIPPING_OPTIONS).map(addLabel);
</script>

<SelectSingle
    bind:key = { key }
    { label }
    name = 'auction.shipping.option'
    options = { OPTIONS }
    { placeholder }
    { isDisabled }
    { isRequired }
    { whitelist }
/>